import { createFileRoute } from '@tanstack/react-router'
// import { RobotCreatePage } from '@/pages/robots/RobotCreate'
import FeatureInDevelopmentRobot from '@/components/ui/FeatureInDevelopmentRobot'

export const Route = createFileRoute('/_private/robots/create')({
    component: FeatureInDevelopmentRobot,
})